async function deriveKey(token) {
    const encoder = new TextEncoder();
    const keyMaterial = await crypto.subtle.importKey("raw", encoder.encode(token), {name: "PBKDF2"}, false, ["deriveKey"]);

    return crypto.subtle.deriveKey({
        name: "PBKDF2", salt: encoder.encode("test-salt"), // Фиксированная соль (можно усложнить)
        iterations: 100000, hash: "SHA-256"
    }, keyMaterial, {name: "AES-GCM", length: 256}, false, ["encrypt", "decrypt"]);
}

async function encryptData(data, key) {
    const encoder = new TextEncoder();
    const iv = crypto.getRandomValues(new Uint8Array(12)); // Генерация IV
    const encryptedData = await crypto.subtle.encrypt({name: "AES-GCM", iv}, key, encoder.encode(data));

    return {
        iv: Array.from(iv), data: Array.from(new Uint8Array(encryptedData))
    };
}

async function decryptData(encryptedObject, key) {
    try {
        const decoder = new TextDecoder();
        const iv = new Uint8Array(encryptedObject.iv);
        const encryptedData = new Uint8Array(encryptedObject.data);
        const decryptedData = await crypto.subtle.decrypt({name: "AES-GCM", iv}, key, encryptedData);

        return decoder.decode(decryptedData);
    } catch (error) {
        console.error("Decryption failed:", error);
        return null;
    }
}


async function hashStorageKey(problemId, token) {
    const encoder = new TextEncoder();
    const data = encoder.encode(problemId + token);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return btoa(String.fromCharCode(...new Uint8Array(hashBuffer))).substring(0, 32);
}

export async function saveAnswer(problemId, token, answer) {
    const key = await deriveKey(token);
    const encrypted = await encryptData(answer, key);
    const storageKey = await hashStorageKey(problemId, token);
    localStorage.setItem(storageKey, JSON.stringify(encrypted));
}

export async function loadAnswer(problemId, token) {
    const key = await deriveKey(token);
    const storageKey = await hashStorageKey(problemId, token);
    const storedData = localStorage.getItem(storageKey);

    if (!storedData) return null;
    return await decryptData(JSON.parse(storedData), key);
}
window.saveAnswer = saveAnswer;
window.loadAnswer = loadAnswer;
